import SpriteSymbol from "../../../../../doctor/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../doctor/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "IconCall",
  "use": "IconCall-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"IconCall\"><path d=\"M19.236 15.275l-2.545-.29a1.995 1.995 0 0 0-1.643.57L13.204 17.4a15.076 15.076 0 0 1-6.603-6.603l1.854-1.854c.43-.43.64-1.032.57-1.643l-.29-2.525A2.005 2.005 0 0 0 6.741 3H5.008c-1.133 0-2.074.942-2.004 2.074.53 8.557 7.375 15.391 15.922 15.922 1.132.07 2.074-.871 2.074-2.004V17.26a1.986 1.986 0 0 0-1.764-1.984z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol